// Single source of truth for the API base URL.
// Web build (behind nginx): REACT_APP_API_URL unset -> same-origin "/api".
// Native app build (Capacitor): there is NO same origin, so REACT_APP_API_URL
// MUST be set to an absolute URL (see .env / .env.production) or requests fail.
export const API_BASE = process.env.REACT_APP_API_URL || '/api';

// The origin the public site is published under, for canonical and hreflang.
// A constant rather than window.location.origin because those tags must name
// the indexable site even when the same bundle is running somewhere else — the
// Android app has no meaningful origin, and a canonical pointing at
// capacitor://localhost would be worse than none.
export const SITE_ORIGIN = process.env.REACT_APP_SITE_ORIGIN || 'https://glamgo.hair';

// Shown wherever a product has no photograph of its own.
//
// It is a local file, and it is deliberately not a photograph: every fallback
// image on the site used to be a stock portrait hotlinked from Unsplash, which
// put a third party in the request path of every page load (undisclosed, and
// flatly contradicting the privacy policy's "no third-party trackers") and
// advertised our products with pictures of someone else's. A neutral local
// placeholder says "no photo yet" without pretending to be the product.
export const PLACEHOLDER_IMG = '/img/product-placeholder.svg';
